<div class="tabs">
  <nav
    mat-tab-nav-bar
    class="themed-tab-nav">
    <a
      mat-tab-link
      *ngFor="let tab of tabs"
      (click)="switchTab(tab.value)"
      [active]="(tabParam$ | async) == tab.value"
      [attr.data-cy]="'state-' + tab.value + '-toggle-button'">
      {{ tab.label | i18n }}
    </a>
  </nav>
</div>
<div>
  <p>
    {{
      ("conditionalTransfersDescription" | i18n) ||
        "conditional transfers description"
    }}
  </p>
</div>
<div
  class="conditional-transfers-list"
  *ngIf="user$ | async">
  <mat-card
    class="mat-elevation-z2"
    *ngFor="let conditionalTransfer of conditionalTransfers$ | async">
    <mat-card-content>
      <div class="row">
        <div class="col">
          <app-certificate-select
            [selectedMappedCertificates]="
              conditionalTransfer.certificates || []
            "
            (selectionChanged)="
              certificatesSelected(conditionalTransfer, $event)
            ">
          </app-certificate-select>
        </div>
      </div>
      <div
        class="row"
        *ngFor="
          let condition of conditionalTransfer.conditions;
          let index = index
        ">
        <div class="col">
          <div class="row">
            <div class="col-1 priority-input">
              <button
                type="button"
                class="movement-chevron"
                [disabled]="index === 0"
                (click)="increaseConditionPriority(conditionalTransfer, index)">
                <mat-icon
                  svgIcon="chevron-down"
                  class="rotate"></mat-icon>
              </button>
              <span class="index-count"> {{ index + 1 }} </span>
              <button
                type="button"
                class="movement-chevron"
                [disabled]="index === conditionalTransfer.conditions.length - 1"
                (click)="decreaseConditionPriority(conditionalTransfer, index)">
                <mat-icon svgIcon="chevron-down"></mat-icon>
              </button>
            </div>
            <div class="col-10">
              <mat-form-field>
                <mat-label>
                  {{
                    ("hoursBeforeJobStart" | i18n) || "Stunden vor Dienstbeginn"
                  }}
                </mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="condition.hoursBeforeJobStart"
                  [attr.name]="'hoursBeforeJobStart-' + conditionalTransfer.id"
                  [attr.data-cy]="
                    'hoursBeforeJobStart-' + conditionalTransfer.id
                  " />
              </mat-form-field>
            </div>
            <div class="col-1">
              <button
                class="remove-customer-group-button"
                type="button"
                (click)="removeConditionGroup(conditionalTransfer, index)">
                <mat-icon
                  class="remove-customer-group-button-icon"
                  svgIcon="delete-trash-remove"></mat-icon>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-2 col-md-1"></div>
            <div class="col-10 col-md-11">
              <div class="transfer-customer-group-list">
                <div
                  *ngFor="
                    let transferCustomerGroup of condition.transferCustomerGroups;
                    let i = index
                  ">
                  <div class="row">
                    <div class="col-2 col-md-1 priority-input">
                      <button
                        type="button"
                        class="movement-chevron"
                        [disabled]="i === 0"
                        (click)="increaseCustomerGroupPriority(condition, i)">
                        <mat-icon
                          svgIcon="chevron-down"
                          class="rotate"></mat-icon>
                      </button>
                      <span class="index-count"> {{ i + 1 }} </span>
                      <button
                        type="button"
                        class="movement-chevron"
                        [disabled]="
                          i === condition.transferCustomerGroups.length - 1
                        "
                        (click)="decreaseCustomerGroupPriority(condition, i)">
                        <mat-icon svgIcon="chevron-down"></mat-icon>
                      </button>
                    </div>
                    <div class="col-10 col-md-8">
                      <app-customer-select
                        [selectedCustomers]="
                          transferCustomerGroup.preferredTransferCustomers
                        "
                        [restrictToCustomerIds]="condition.possibleCustomerIds"
                        [includeTransferCustomers]="true"
                        (selectionChanged)="
                          updateCustomersOfGroup(
                            $event,
                            transferCustomerGroup,
                            condition
                          )
                        ">
                      </app-customer-select>
                    </div>
                    <div class="col-10 col-md-2 align-self-end">
                      <mat-form-field>
                        <mat-label>
                          {{
                            ("blockingHours" | i18n) || "blockierende Stunden"
                          }}
                        </mat-label>
                        <input
                          matInput
                          [(ngModel)]="transferCustomerGroup.blockingHours"
                          type="number"
                          [attr.name]="
                            'blockingHours-' + conditionalTransfer.id
                          "
                          [attr.data-cy]="
                            'blockingHours-' + conditionalTransfer.id
                          " />
                      </mat-form-field>
                    </div>
                    <div class="col-2 col-md-1">
                      <button
                        class="remove-customer-group-button"
                        type="button"
                        (click)="removeCustomerGroup(condition, i)">
                        <mat-icon
                          class="remove-customer-group-button-icon"
                          svgIcon="delete-trash-remove"></mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <button
                      class="outline-pill-button icon-left add-customer-group-button"
                      type="button"
                      (click)="addNewCustomerGroup(condition)">
                      <mat-icon
                        class="custom-text-icon-button-icon"
                        svgIcon="add-circle-plus"></mat-icon>
                      {{ ("addCustomerGroup" | i18n) || "add customer group" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            class="outline-pill-button icon-left add-condition-group-button"
            type="button"
            (click)="addNewConditionGroup(conditionalTransfer)">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{ ("addConditionGroup" | i18n) || "add condition group" }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            mat-button
            type="button"
            class="delete-button"
            (click)="removeConditionalTransfer(conditionalTransfer.id)">
            <mat-icon svgIcon="delete-trash-remove"></mat-icon>
            <span class="mat-fab__label">
              {{ ("remove" | i18n) || "entfernen" | uppercase }}</span
            >
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="row mt-4">
    <div class="col">
      <button
        class="outline-pill-button icon-left"
        type="button"
        data-cy="add-condition-button"
        (click)="addNewConditionalTransfer()">
        <mat-icon
          class="custom-text-icon-button-icon"
          svgIcon="add-circle-plus"></mat-icon>
        {{
          ("addConditionalTransfer" | i18n) || "add conditional transfer values"
        }}
      </button>
    </div>
  </div>
</div>
<div class="floating-actions-bar">
  <button
    (click)="cancelChanges()"
    class="secondary-pill-button icon-left big-fab"
    type="button"
    data-cy="cancel-conditional-transfers-button">
    <mat-icon svgIcon="close"></mat-icon>
    {{ ("cancel" | i18n) || "cancel" | titlecase }}
  </button>
  <button
    (click)="saveConditionalTransfers()"
    class="primary-pill-button icon-left big-fab"
    type="button"
    data-cy="save-conditional-transfers-button">
    <mat-icon svgIcon="save"></mat-icon>
    {{ ("save" | i18n) || "save" | titlecase }}
  </button>
</div>
